import React, { Component } from 'react';

class SalesInfo extends Component {
  isThisMonth = d => {
    // Firestore Timestamp tiene seconds y nanoseconds
    const orderDate = new Date(d.seconds * 1000);
    const today = new Date();

    return (
      orderDate.getMonth() === today.getMonth() && orderDate.getFullYear() === today.getFullYear()
    );
  };

  isThisYear = d => {
    const orderDate = new Date(d.seconds * 1000);
    const today = new Date();

    return orderDate.getFullYear() === today.getFullYear();
  };

  render() {
    const { data } = this.props;
    let totalIncomeThisMonth = 0;
    let totalIncomeThisMonthUYU = 0;

    let totalIncomeAnnual = 0;
    let totalIncomeAnnualUYU = 0;

    let totalOrders = 0;
    let totalOrdersAnual = 0;
    if (data && data.length > 0) {
      data.forEach(element => {
        if (element.status == 'approved' && this.isThisMonth(element.createdAt)) {
          if (element?.items?.length) {
            const { currency } = element.items[0];
            if (currency == 'UYU') {
              totalIncomeThisMonthUYU += element.amount;
            } else {
              totalIncomeThisMonth += element.amount;
            }
            totalOrders++;
          }
        }
        if (element.status == 'approved' && this.isThisYear(element.createdAt)) {
          if (element?.items?.length) {
            const { currency } = element.items[0];
            if (currency == 'UYU') {
              totalIncomeAnnualUYU += element.amount;
            } else {
              totalIncomeAnnual += element.amount;
            }
            totalOrdersAnual++;
          }
        }
      });
    }
    return (
      <div>
        <div>MENSUAL:</div>

        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="stats-card">
              <div className="media align-items-center justify-content-between">
                <div className="ml-0">
                  <h3>Total ingresos</h3>
                  <p>(Este mes)</p>
                </div>
                <div className="avatar avatar-pink">
                  <i className="bx bxs-badge-dollar"></i>
                </div>
              </div>

              <h4 className="growth">USD${totalIncomeThisMonth}</h4>
              <h4 style={{ marginBottom: '0px' }}>+</h4>
              <h4 className="growth" style={{ marginTop: '0px' }}>
                UYU${totalIncomeThisMonthUYU}
              </h4>
            </div>
          </div>
          <div className="col-lg-3 col-md-6">
            <div className="stats-card">
              <div className="media align-items-center justify-content-between">
                <div className="ml-0">
                  <h3>Cant. de ventas</h3>
                  <p>(Este mes)</p>
                </div>
                <div className="avatar avatar-blue">
                  <i className="bx bx-cart-alt"></i>
                </div>
              </div>

              <h4 className="growth">{totalOrders}</h4>
            </div>
          </div>
        </div>

        <div>ANUAL:</div>
        <div className="row">
          <div className="col-lg-3 col-md-6">
            <div className="stats-card">
              <div className="media align-items-center justify-content-between">
                <div className="ml-0">
                  <h3>Total ingresos</h3>
                  <p>(Este año)</p>
                </div>
                <div className="avatar avatar-pink">
                  <i className="bx bxs-badge-dollar"></i>
                </div>
              </div>

              <h4 className="growth">USD${totalIncomeAnnual}</h4>
              <h4 style={{ marginBottom: '0px' }}>+</h4>
              <h4 className="growth" style={{ marginTop: '0px' }}>
                UYU${totalIncomeAnnualUYU}
              </h4>
            </div>
          </div>

          <div className="col-lg-3 col-md-6">
            <div className="stats-card">
              <div className="media align-items-center justify-content-between">
                <div className="ml-0">
                  <h3>Cant. de ventas</h3>
                  <p>(Este año)</p>
                </div>
                <div className="avatar avatar-blue">
                  <i className="bx bx-cart-alt"></i>
                </div>
              </div>

              <h4 className="growth">{totalOrdersAnual}</h4>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SalesInfo;
